module.exports = __webpack_public_path__ + "img/mail-icon.db9e9bd2.png";